import { customStorage } from './CommonService';

const CHECK_INTERVAL_MS = 60_000;
const RELOAD_MARKER = 'pwf-reloaded-build';

export const getLoadedMainBundle = (documentRef = document) => {
    const script = [...documentRef.scripts].find(item => /\/static\/js\/main\.[^/]+\.js(?:$|\?)/.test(item.src));
    return script?.src ? new URL(script.src, window.location.href).pathname : '';
};

export const checkForFrontendUpdate = async ({
    fetchImpl = window.fetch.bind(window),
    documentRef = document,
    storage = customStorage.session,
    reload = () => window.location.reload(),
} = {}) => {
    const loadedBundle = getLoadedMainBundle(documentRef);
    if (!loadedBundle) return false;

    const basePath = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    const response = await fetchImpl(`${basePath}/asset-manifest.json`, { cache: 'no-store' });
    if (!response.ok) return false;
    const manifest = await response.json();
    const deployedBundleUrl = manifest?.files?.['main.js'];
    const deployedBundle = deployedBundleUrl ? new URL(deployedBundleUrl, window.location.href).pathname : '';
    if (!deployedBundle || deployedBundle === loadedBundle) return false;

    if (storage.getItem(RELOAD_MARKER) === deployedBundle) return false;
    storage.setItem(RELOAD_MARKER, deployedBundle);
    reload();
    return true;
};

export const startFrontendDeploymentMonitor = () => {
    if (process.env.NODE_ENV !== 'production') return () => {};

    const check = () => checkForFrontendUpdate().catch(() => false);
    check();
    const intervalId = window.setInterval(check, CHECK_INTERVAL_MS);
    const checkWhenVisible = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', checkWhenVisible);
    window.addEventListener('online', check);

    return () => {
        window.clearInterval(intervalId);
        document.removeEventListener('visibilitychange', checkWhenVisible);
        window.removeEventListener('online', check);
    };
};

